import * as CommonUtilities from "../../../../common/utils/CommonUtils";
import defaultImage from "../../../../images/default.jpg";

export default function ModifierChildProductCombo(props) {

    let modifierPriceInc = CommonUtilities.formatDisplayPrice(props.modifierDetails.priceInc);

    let isDisabled = props.addToProductComboError.ButtonsDisabled || !props.currentLocation.AllowOnlineOrder || !props.currentLocation.Validation.IsValidTableNumber;
    let isDisabledCursor = isDisabled ? "default" : "pointer";

    // Modifiers
    let modifierLabel;
    let priceLabel;
    let modifierSelector;
    // Add-ons show a price whenever they cost something. Substitutions override
    // this below — they show one only when the swap costs extra.
    let showPriceLabel = props.modifierDetails.priceInc != 0;

    if (props.type === "Check") { // Check
        modifierLabel = <label className="form-check-label col" htmlFor={`CheckModCatId${props.modCatId}ModId${props.modifierDetails.modId}`} style={{cursor: isDisabledCursor}}>{props.modifierDetails.modName}</label>
        priceLabel = <label className="ms-1 me-4 form-check-label" htmlFor={`CheckModCatId${props.modCatId}ModId${props.modifierDetails.modId}`} style={{cursor: isDisabledCursor}}>{modifierPriceInc}</label>
        modifierSelector = <div className="form-check ms-1">
                                <input className="form-check-input" type="checkbox" value="" data-modplu={props.modifierDetails.modPLUNumber} data-priceinc={props.modifierDetails.priceInc} name={`CheckModCatId${props.modCatId}ModId${props.modifierDetails.modId}`} id={`CheckModCatId${props.modCatId}ModId${props.modifierDetails.modId}`} checked={props.isChecked} onChange={props.handleProductComboModFormChange} disabled={isDisabled} style={{cursor: isDisabledCursor}} />
                            </div>
    } else if (props.type === "Radio") { // Radio
        modifierLabel = <label className="form-check-label col" htmlFor={`RadioModCatId${props.modCatId}ModId${props.modifierDetails.modId}`} style={{cursor: isDisabledCursor}}>{props.modifierDetails.modName}</label>
        priceLabel = <label className="ms-1 me-4 form-check-label" htmlFor={`RadioModCatId${props.modCatId}ModId${props.modifierDetails.modId}`} style={{cursor: isDisabledCursor}}>{modifierPriceInc}</label>
        modifierSelector = <div className="form-check ms-1">
                                <input className="form-check-input" type="radio" value={props.modifierDetails.modId} data-modplu={props.modifierDetails.modPLUNumber} data-priceinc={props.modifierDetails.priceInc} name={`RadioModCatId${props.modCatId}`} id={`RadioModCatId${props.modCatId}ModId${props.modifierDetails.modId}`} checked={props.isChecked == props.modifierDetails.modId} onChange={props.handleProductComboModFormChange} disabled={isDisabled} style={{cursor: isDisabledCursor}} />
                            </div>
    } else if (props.type === "Substitution") { // Substitution
        /* ⚠ INSIDE A COMBO a substitution is a DIFFERENCE, not a price.
           The combo is sold at a set price; swapping Regular for Large costs the
           gap between them, and swapping down costs nothing back — you just get
           less. So show "+$2.50" for an upgrade and NOTHING at all otherwise.
           Showing the substitute's own price ($4.00 / $5.00 / $7.50) implies the
           combo is priced per item, which it is not.

           This mirrors the server: TemporaryUserCartRepository computes
           PriceInc - originalRec.PriceInc and (with the 2026-10-07 clamp) floors
           it at zero. If that clamp is ever removed, this display and the amount
           charged will disagree.

           ⚠ Combo only. On a standalone product the customer really is buying
           that size, so ModifierModal.js keeps showing absolute prices. */
        const substitutionDelta = props.modifierDetails.priceInc - props.priceInc;
        showPriceLabel = substitutionDelta > 0;
        const deltaDisplay = `+${CommonUtilities.formatDisplayPrice(substitutionDelta)}`;

        modifierLabel = <label className="form-check-label col" htmlFor={`SubRadioModCatId${props.modCatId}ModId${props.modifierDetails.modId}`} style={{cursor: isDisabledCursor}}>{props.modifierDetails.modName}</label>
        priceLabel = <label className="ms-1 me-4 form-check-label" htmlFor={`SubRadioModCatId${props.modCatId}ModId${props.modifierDetails.modId}`} style={{cursor: isDisabledCursor}}>{deltaDisplay}</label>
        modifierSelector = <div className="form-check ms-1">
                                <input className="form-check-input" type="radio" value={props.modifierDetails.modId} data-modplu={props.modifierDetails.modPLUNumber} data-priceinc={props.modifierDetails.priceInc} name={`SubRadioModCatId${props.modCatId}`} id={`SubRadioModCatId${props.modCatId}ModId${props.modifierDetails.modId}`} checked={props.isChecked == props.modifierDetails.modId} onChange={props.handleProductComboModFormChange} disabled={isDisabled} style={{cursor: isDisabledCursor}} />
                            </div>
    }

    return (
        <div className="col-12 wo-opt__row">
            {CommonUtilities.StaticFields.ShowModifierImages ? 
            <div className="wo-opt__thumb">
                <img src={props.modifierDetails.modImageURL ? props.modifierDetails.modImageURL : defaultImage} alt="" loading="lazy" decoding="async"></img>
            </div>
            : <></>}
            {modifierLabel}
            <div className="wo-opt__pick">
                {showPriceLabel && priceLabel}
                {modifierSelector}
            </div>
        </div>
    )
}